import { RefObject, useEffect } from 'react';

export function useHubSpotButtonStyles(
	containerRef: RefObject<HTMLDivElement>,
	formHtmlCode: string,
	buttonStyle: 'primary' | 'secondary',
	isMounted: boolean,
) {
	useEffect(() => {
		if (!containerRef.current || !isMounted) return;

		const container = containerRef.current;

		function applyButtonStyles(button: HTMLButtonElement) {
			try {
				if (buttonStyle === 'primary') {
					button.classList.add('hubspot-Button___primary');
					button.classList.remove('hubspot-Button___secondary');
				} else {
					button.classList.add('hubspot-Button___secondary');
					button.classList.remove('hubspot-Button___primary');
				}
				button.style.removeProperty('background');
				button.style.removeProperty('background-color');
				button.style.removeProperty('color');
				button.style.removeProperty('border-color');
			} catch (error) {
				console.warn('Failed to apply button styles:', error);
			}
		}

		container.querySelectorAll<HTMLButtonElement>('.hsfc-Button').forEach(applyButtonStyles);

		const observer = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				mutation.addedNodes.forEach((node) => {
					if (!(node instanceof HTMLElement)) return;
					if (node.matches('.hsfc-Button')) applyButtonStyles(node as HTMLButtonElement);
					node.querySelectorAll<HTMLButtonElement>('.hsfc-Button').forEach(applyButtonStyles);
				});
			}
		});

		observer.observe(container, { childList: true, subtree: true });
		return () => observer.disconnect();
	}, [formHtmlCode, buttonStyle, isMounted]);
}
